import Marquee from "react-fast-marquee";
import { useContent } from "@/content/ContentContext";

export const MarqueeStrip = ({ items }) => {
  const content = useContent();
  const list = (items || content.marquee).filter(Boolean);

  return (
    <section
      data-testid="marquee-strip"
      className="border-y border-foreground/10 bg-primary py-4 text-primary-foreground"
    >
      <Marquee speed={40} gradient={false} pauseOnHover>
        {list.map((item, i) => (
          <span
            key={i}
            className="flex items-center font-heading text-lg font-bold uppercase tracking-wider md:text-xl"
          >
            <span className="px-8">{item}</span>
            <span className="h-2.5 w-2.5 rotate-45 bg-primary-foreground/60" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
